import { useState } from 'react';
import './PasswordPromptModal.css';

interface PasswordPromptModalProps {
  roomName: string;
  onSubmit: (password: string) => void;
  onCancel: () => void;
  error?: string;
  isSubmitting?: boolean;
}

export function PasswordPromptModal({ roomName, onSubmit, onCancel, error, isSubmitting }: PasswordPromptModalProps) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content password-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Room Password Required</h2>
          <button className="close-btn" onClick={onCancel}>&times;</button>
        </div>

        <p className="room-name-label">Joining: <strong>{roomName}</strong></p>

        {error && (
          <div className="error-message">
            {error === 'INVALID_PASSWORD' ? 'Incorrect password. Please try again.' : error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Enter Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Room password"
              autoFocus
              disabled={isSubmitting}
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={!password.trim() || isSubmitting}>
              {isSubmitting ? 'Joining...' : 'Join Room'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
